import type {
  IMediaPluginService,
  IMessage,
  PluginsDataMap,
  PublicCommands,
  UploadedData,
} from './../../ricos-types';

export type UpdateService = ReturnType<typeof createUpdateService>;

export const createUpdateService = () => {
  let publicCommands!: PublicCommands;

  return {
    setEditorCommands: (_publicCommands: PublicCommands) => {
      publicCommands = _publicCommands;
    },

    updatePluginData: (
      uploadedData: UploadedData,
      nodeId: string,
      type: string,
      mediaPluginService: IMediaPluginService,
      fileState?: Record<string, string | number>
    ): void => {
      if (doesNodeExist(nodeId, publicCommands)) {
        const componentData = publicCommands?.getBlockComponentData(nodeId);

        const newComponentData = mediaPluginService.createPluginData(
          uploadedData,
          componentData,
          fileState
        );
        publicCommands?.setBlock(nodeId, type as keyof PluginsDataMap, newComponentData);
      }
    },

    updateLoadingState: (
      url: unknown,
      file: File,
      nodeId: string,
      type: string,
      mediaPluginService: IMediaPluginService,
      fileState?: Record<string, string | number>
    ): Record<string, string | number> | undefined => {
      if (doesNodeExist(nodeId, publicCommands)) {
        const currentComponentData = publicCommands?.getBlockComponentData(nodeId);
        const {
          componentState,
          componentData,
          fileState: newFileState,
        } = mediaPluginService.createLoadingData(file, url, currentComponentData, fileState);

        publicCommands?.setBlock(nodeId, type as keyof PluginsDataMap, {
          ...componentData,
          ...componentState,
        });
        return newFileState;
      }
    },

    updateErrorState: (
      error: IMessage,
      nodeId: string,
      type: string,
      mediaPluginService: IMediaPluginService,
      fileState?: Record<string, string | number>
    ): void => {
      if (doesNodeExist(nodeId, publicCommands)) {
        const componentData = publicCommands?.getBlockComponentData(nodeId);
        const newComponentData = mediaPluginService.createErrorData(
          error,
          componentData,
          fileState
        );
        publicCommands?.setBlock(nodeId, type as keyof PluginsDataMap, newComponentData);
      }
    },
  };
};

const doesNodeExist = (nodeId: string, publicCommands?: PublicCommands) =>
  publicCommands?.getAllBlocksKeys().includes(nodeId);
